import { redirect } from "react-router-dom";

// export function getTokenDuration() {
//     const storedExpirationDate = localStorage.getItem("expiration");
//     const expirationDate = new Date(storedExpirationDate);
//     const now = new Date();
//     const duration = expirationDate.getTime() - now.getTime();
//     return duration;
// }

export function getAuthToken() {
    const token = localStorage.getItem("token");
    const client = localStorage.getItem("client");

    if (!token) {
        return null;
    }

    const authCredentials = {
        token,
        client,
    }

    return authCredentials;
}

export function tokenLoader() {
    return getAuthToken();
}

export function checkAuthLoader() {
    const authCredentials = getAuthToken();

    if (
        !authCredentials ||
        !authCredentials.token ||
        !authCredentials.client ||
        authCredentials.token === "null" ||
        authCredentials.client === "null"
    ) {
        return redirect('/');
    }

    return null;
}
